import { ArrowUpRight, Clock3, Mail, MapPin, Phone } from "lucide-react";
import { contactDetails } from "../data/siteContent";
import { usePublicContent } from "../hooks/use-public-content";

export default function ContactPage() {
  const { data } = usePublicContent();
  const details = data?.settings ? { contacts: data.settings.contacts, email: data.settings.email, location: data.settings.address, hours: data.settings.hours } : contactDetails;
  return (
    <main className="v2-public v2-inner-page" data-testid="contact-page">
      <section className="v2-contact-hero" data-testid="contact-hero-section">
        <span className="v2-overline">Contact NCP Mechanical</span>
        <h1 data-testid="contact-title">Let’s talk about<br /><em>your next project.</em></h1>
        <p data-testid="contact-lead">Share the location, programme and mechanical package. We’ll come back with a clear, practical next step.</p>
      </section>
      <section className="v2-contact-layout" data-testid="contact-details-section">
        <div className="v2-contact-primary">
          <span className="v2-contact-label">Call our team</span>
          {details.contacts.map((contact, index) => (
            <a className="v2-contact-person" href={`tel:${contact.phone.replace(/\s/g, "")}`} data-testid={`contact-phone-link-${index + 1}`} key={contact.name}>
              <span><small>{contact.name}</small>{contact.phone}</span><ArrowUpRight />
            </a>
          ))}
          <span className="v2-contact-label">Email us</span>
          <a href={`mailto:${details.email}`} data-testid="contact-email-link">{details.email}<ArrowUpRight /></a>
        </div>
        <div className="v2-contact-meta">
          <div data-testid="contact-location"><MapPin /><span><small>Based in</small>{details.location}</span></div>
          <div data-testid="contact-hours"><Clock3 /><span><small>Working hours</small>{details.hours}</span></div>
          <div data-testid="contact-service-area"><Phone /><span><small>Direct contacts</small>Catalin & Iulian</span></div>
          <div data-testid="contact-response"><Mail /><span><small>Response</small>During working hours</span></div>
        </div>
      </section>
      <section className="v2-contact-note" data-testid="contact-note-section"><span className="v2-overline">Helpful information</span><p data-testid="contact-note-text">A brief scope, project location, programme and drawings or photographs will help us understand your requirements quickly.</p></section>
    </main>
  );
}